import './lib/uuid';
import { Factory } from 'rosie';

Factory.define('SidekickOrgConfiguration').attr('v1CustomerId');
